// Unexpected Gratitude Template - Common App Prompt #4
export const unexpectedGratitudeTemplate = {
  id: 'unexpectedGratitude',
  title: 'Unexpected Gratitude',
  description: 'For reflecting on something someone did that made you happy or thankful in a surprising way',
  sections: [
    {
      id: 'the_surprising_moment',
      label: 'The Surprising Moment',
      type: 'opening',
      prompt: 'Take me to the exact moment when someone did something that caught you completely off guard.',
      coachVoice: "I want the surprise factor. What did someone do that you never would have expected, and why was it so unexpected?",
      sample: "Mr. Rodriguez, my notoriously tough calculus teacher, quietly slipped a note into my backpack as I left class after bombing another quiz. It simply read: 'Your approach to problem #3 was brilliant, even though your arithmetic was wrong. Want to talk about it after school?' I'd been so focused on my failing grade, I'd missed that my thinking was actually sophisticated.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'why_it_hit_differently',
      label: 'Why It Hit Differently',
      type: 'stakes',
      prompt: 'What was it about this specific act that affected you more than typical kindness would have?',
      coachVoice: "Don't just say it was nice. Explain why THIS gesture, from THIS person, at THIS moment, hit you in a way that ordinary kindness wouldn't have.",
      sample: "For months, I'd been seeing myself as the 'dumb kid' in advanced math, convinced I didn't belong. But Mr. Rodriguez saw something I couldn't see in myself - that struggling with calculations didn't mean I lacked mathematical insight. He recognized my thinking process was valuable even when my execution failed.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'how_gratitude_motivated_action',
      label: 'How Gratitude Motivated Action',
      type: 'approach',
      prompt: 'Show me the specific ways this gratitude changed how you approach relationships, challenges, or opportunities.',
      coachVoice: "Gratitude that just makes you feel warm and fuzzy is nice. I want to see gratitude that made you DO something differently.",
      sample: "I started looking for that same hidden value in my struggling classmates. During study sessions, instead of just correcting wrong answers, I began saying things like 'that's an interesting approach - let's see where it leads' or 'you're asking the right kind of question.' I realized I could be the person who sees others' potential when they can't see it themselves.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'gratitude_as_your_practice',
      label: 'Gratitude as Your Practice',
      type: 'growth',
      prompt: 'How has this experience made you more intentional about recognizing or creating moments of meaningful gratitude?',
      coachVoice: "I want to see how this changed your relationship with gratitude itself. Give me evidence of how you now create these moments for others or recognize them more deeply.",
      sample: "I now write one specific appreciation note to a teacher, coach, or friend every week - not generic thank-yous, but observations about what they do that they might not realize matters. When my little sister was struggling with reading, I left sticky notes on her books highlighting not just correct answers, but creative thinking. I've learned that the most powerful gratitude notices what people can't see in themselves.",
      minWords: 80
    }
  ]
};